import script from "./CollapsableFloatingPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollapsableFloatingPanel.vue?vue&type=script&setup=true&lang=ts"

import "./CollapsableFloatingPanel.vue?vue&type=style&index=0&id=0c768c38&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c768c38"]])

export default __exports__